// VideoThumbnail.js
import React, { useState, useEffect, useRef } from 'react';
import ApiContext from './ApiContext';

const VideoThumbnail = ({ video, onPlay }) => {
    const { baseUrl } = React.useContext(ApiContext);
    const [isVisible, setIsVisible] = useState(false);
    const thumbnailRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(thumbnailRef.current);
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (thumbnailRef.current) {
            observer.observe(thumbnailRef.current);
        }

        return () => {
            if (thumbnailRef.current) {
                observer.unobserve(thumbnailRef.current);
            }
        };
    }, []);

    const bytesToMB = (bytes) => {
        return (bytes / 1048576).toFixed(1); // Konvertiert Bytes in MB und rundet auf eine Dezimalstelle
    };

    const [linkIconEnlarged, setLinkIconEnlarged] = useState(false);

    const copyLinkToClipboard = () => {
        const dummy = document.createElement('input');
        const url = `${window.location.origin}/?findVideo=${video.filename}`;
        document.body.appendChild(dummy);
        dummy.value = url;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);

        // Vergrößern des Icons
        setLinkIconEnlarged(true);
        setTimeout(() => setLinkIconEnlarged(false), 500); // Nach 500ms (0.5s) wird es wieder in den ursprünglichen Zustand zurückgesetzt
    };

    const handlePlayClick = (selectedVideo) => {
        const newUrl = `${window.location.origin}/?findVideo=${selectedVideo.filename}`;
        window.history.pushState({}, '', newUrl);
        onPlay(selectedVideo);
    };

    return (
        <div ref={thumbnailRef} className="thumbnail" data-filename={video.filename}>
            {isVisible ? (
                <>
                    {video.videoUrl.includes("timelapse") && (
                        <div className="timelapse-label">Zeitraffer</div>
                    )}
                    <img className="thumbnail_img" src={video.thumbnailUrl} alt={`Thumbnail for ${video.creationDate} ${video.creationTime}`} onClick={() => handlePlayClick(video)} />
                    <div className="thumbnail-text">
                        <p>
                            <span className="bold-text">Datum: </span>
                            <span className="light-text">{video.creationDate}</span>
                        </p>
                        <p>
                            <span className="bold-text">Uhrzeit: </span>
                            <span className="light-text">{video.creationTime}</span>
                        </p>
                        <p>
                            <span className="bold-text">Dateigröße: </span>
                            <span className="light-text">{bytesToMB(video.size)} MB</span>
                        </p>
                        <p>
                            <span className="bold-text">Dauer: </span>
                            <span className="light-text">{video.duration}</span>
                        </p>
                        <div className="video-tags">
                            {video.tags && video.tags.length > 0 && (
                                video.tags.map((tag, index) => (
                                    <span key={index} className="video-tag">{tag}</span>
                                ))
                            )}
                        </div>
                    </div>
                    <div className="download-icon"><a href={video.videoUrl} download target="_blank"><img src="download.png" alt="Download Icon" /></a></div>
                    <div className="facebook-share-icon" onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${baseUrl}/getVideoForFacebook?file=${video.filename}`, '_blank')}></div>
                    <div className={`link-icon ${linkIconEnlarged ? 'enlarged' : ''}`} onClick={copyLinkToClipboard}></div>
                </>
            ) : (
                <div className="thumbnail-placeholder">Loading...</div>
            )}
        </div>
    );
};

export default VideoThumbnail;
